import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { OperationsTrackerService } from '../operations-tracker/operations-tracker.service';

@Injectable({
  providedIn: 'root'
})
export class ActionDispatcherService {
  constructor(private store: Store, private operationsTrackerService: OperationsTrackerService) {}

  /**
   * Helper method that dispatches provided action and waits
   * until this action completly done using operation tracker service
   */
  async dispatchActionAsync<T = unknown>(action: Action, operationId: string, operationPartition?: string): Promise<T> {
    const delayedResponse = firstValueFrom(
      this.operationsTrackerService.getOperationData(operationId, operationPartition),
    );

    this.store.dispatch(action);
    return delayedResponse as T;
  }
}
